import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Phase';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.37197 11.25C7.06309 12.1239 6.22966 12.75 5.25 12.75C4.00736 12.75 3 11.7426 3 10.5C3 9.25736 4.00736 8.25 5.25 8.25C6.22966 8.25 7.06309 8.87611 7.37197 9.75H16.628C16.9369 8.87611 17.7703 8.25 18.75 8.25C19.9926 8.25 21 9.25736 21 10.5C21 11.7426 19.9926 12.75 18.75 12.75C17.7703 12.75 16.9369 12.1239 16.628 11.25H7.37197ZM6 10.5C6 10.9142 5.66421 11.25 5.25 11.25C4.83579 11.25 4.5 10.9142 4.5 10.5C4.5 10.0858 4.83579 9.75 5.25 9.75C5.66421 9.75 6 10.0858 6 10.5ZM18.75 11.25C19.1642 11.25 19.5 10.9142 19.5 10.5C19.5 10.0858 19.1642 9.75 18.75 9.75C18.3358 9.75 18 10.0858 18 10.5C18 10.9142 18.3358 11.25 18.75 11.25Z" fill="currentColor"/>
    <path d="M9 13.5C9 13.0858 8.66421 12.75 8.25 12.75C7.83579 12.75 7.5 13.0858 7.5 13.5V15C7.5 15.4142 7.83579 15.75 8.25 15.75H15.75C16.1642 15.75 16.5 15.4142 16.5 15V13.5C16.5 13.0858 16.1642 12.75 15.75 12.75C15.3358 12.75 15 13.0858 15 13.5V14.25H9V13.5Z" fill="currentColor"/>
  </svg>
`;

const PhaseIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.37197 11.25C7.06309 12.1239 6.22966 12.75 5.25 12.75C4.00736 12.75 3 11.7426 3 10.5C3 9.25736 4.00736 8.25 5.25 8.25C6.22966 8.25 7.06309 8.87611 7.37197 9.75H16.628C16.9369 8.87611 17.7703 8.25 18.75 8.25C19.9926 8.25 21 9.25736 21 10.5C21 11.7426 19.9926 12.75 18.75 12.75C17.7703 12.75 16.9369 12.1239 16.628 11.25H7.37197ZM6 10.5C6 10.9142 5.66421 11.25 5.25 11.25C4.83579 11.25 4.5 10.9142 4.5 10.5C4.5 10.0858 4.83579 9.75 5.25 9.75C5.66421 9.75 6 10.0858 6 10.5ZM18.75 11.25C19.1642 11.25 19.5 10.9142 19.5 10.5C19.5 10.0858 19.1642 9.75 18.75 9.75C18.3358 9.75 18 10.0858 18 10.5C18 10.9142 18.3358 11.25 18.75 11.25Z'
      fill='currentColor'
    />
    <path
      d='M9 13.5C9 13.0858 8.66421 12.75 8.25 12.75C7.83579 12.75 7.5 13.0858 7.5 13.5V15C7.5 15.4142 7.83579 15.75 8.25 15.75H15.75C16.1642 15.75 16.5 15.4142 16.5 15V13.5C16.5 13.0858 16.1642 12.75 15.75 12.75C15.3358 12.75 15 13.0858 15 13.5V14.25H9V13.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: PhaseIcon,
  IconSvg: IconSvg
} as IconType;
